import * as THREE from 'three';
import { Entity } from '../types/Entity';
import type { GameScene } from '../core/Scene';

export class Cookie extends Entity {
  readonly mesh: THREE.Mesh;
  private readonly velocity: THREE.Vector3;

  constructor(spawnPos: THREE.Vector3, speed: number) {
    super();
    const geometry = new THREE.CylinderGeometry(0.25, 0.25, 0.1, 8);
    const material = new THREE.MeshLambertMaterial({ color: 0xd4a44c });
    this.mesh = new THREE.Mesh(geometry, material);
    this.mesh.position.set(spawnPos.x, 0.2, spawnPos.z);

    // Move directly toward the origin at constant speed
    this.velocity = new THREE.Vector3(-spawnPos.x, 0, -spawnPos.z)
      .normalize()
      .multiplyScalar(speed);
  }

  get position(): THREE.Vector3 {
    return this.mesh.position;
  }

  update(delta: number): void {
    this.mesh.position.x += this.velocity.x * delta;
    this.mesh.position.z += this.velocity.z * delta;
    this.mesh.rotation.y += delta * 2;
  }

  addToScene(scene: GameScene): void {
    scene.add(this.mesh);
  }

  removeFromScene(scene: GameScene): void {
    scene.remove(this.mesh);
  }

  dispose(): void {
    (this.mesh.geometry as THREE.BufferGeometry).dispose();
    (this.mesh.material as THREE.Material).dispose();
  }
}
